import React, { memo, useCallback } from 'react';

export const SelectionItem = memo(function SelectionItem({ item, onRemove }) {
    const handleRemove = useCallback(() => {
        onRemove(item.id);
    }, [item.id, onRemove]);

    return (
        <div style={{
            position: 'relative',
            display: 'grid',
            gridTemplateColumns: 'min(50%, 200px) 1fr',
            alignItems: 'center',
            gap: '2rem',
        }}>
            <button
                onClick={handleRemove}
                aria-label={`Remove ${item.name}`}
                style={{
                    position: 'absolute',
                    top: 'calc(50% - 20px / 2)',
                    right: '0',
                    background: 'none',
                    border: 'none',
                    color: '#000000',
                    cursor: 'pointer',
                    fontSize: '18px',
                    padding: '0',
                    lineHeight: 1,
                    fontWeight: '300',
                    width: '20px',
                    height: '20px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                ✕
            </button>

            {item.image && (
                <a style={{
                    width: '100%',
                    aspectRatio: '1',
                    overflow: 'hidden',
                    maxHeight: '200px',
                    background: '#f5f5f5',
                }}
                   href={item.link}
                >
                    <img
                        src={item.image}
                        alt={item.name}
                        style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                        }}
                    />
                </a>
            )}
            <a href={item.link}>
                <h3 style={{
                    fontSize: '15px',
                    fontWeight: '600',
                    margin: '0 0 6px 0',
                    color: '#1a1a1a',
                }}>
                    {item.name}
                </h3>
            </a>
        </div>
    );
});
